export var SiteId;
(function (SiteId) {
    SiteId["GoodLifePlus"] = "a78bc32f-3641-4ef6-8cf5-ee949e257740";
    SiteId["Rangers"] = "6aac1212-a185-4a7f-b0ac-c15dbf6ad37e";
    SiteId["Saints"] = "dca5956a-a6ca-48ab-8765-1828723f44ec";
})(SiteId || (SiteId = {}));
export var ThemeType;
(function (ThemeType) {
    ThemeType["Default"] = "default";
    ThemeType["Club"] = "club";
})(ThemeType || (ThemeType = {}));
